export default __webpack_public_path__ + "static/media/gallery_09.4257c646.jpg";